{
  "no_space": "No space left on device",
  "oops": "Oops!",
  "error_occurred": "Error has occurred",
  "error_occurred_onload": "$t(error:error_occurred)",
  "general_notification_error": "An error occurred. If the problem persists, please contact support.",
  "access_denied": "Access is denied",
  "asset_not_found": "Asset not found",
  "error_tag_value": "Please enter a valid tag value between {{min}} and {{max}}",
  "error_tag_value_no_decimal": "and decimal point not allowed",
  "generic_error_msg": "Something went wrong. Please try again.",
  "empty_name": "Please enter a name",
  "empty_frequency": "Please enter a valid frequency",
  "invalid_name": "Please enter a valid name",
  "invalid_network_area": "Please enter a valid network area",
  "duplicate_name": "This name is already in use",
  "empty_title": "Please enter a title",
  "invalid_title": "Please enter a valid title",
  "duplicate_title": "This title is already in use",
  "empty_group_name": "Please enter a group name",
  "empty_device_name": "Please enter a device name",
  "empty_full_name": "Please enter a full name",
  "invalid_full_name": "Full name can only contain letters, spaces, dots, and hyphens",
  "empty_username": "Please enter a username",
  "empty_cloud_site": "Please enter a cloud site",
  "empty_linking_key": "Please enter a linking key",
  "empty_access_key": "Please enter an access key",
  "empty_secret_key": "Please enter a secret key",
  "empty_repo_id": "Please enter a repository ID",
  "invalid_username": "Please enter a valid username",
  "empty_retype_username": "Please retype your username",
  "wrong_retype_username": "Usernames do not match",
  "duplicate_username": "This username is already in use",
  "empty_email": "Please enter an email",
  "invalid_email": "Please enter a valid email",
  "empty_ip": "Please enter an IP",
  "invalid_ip": "Please enter a valid IP",
  "invalid_cidr": "Value must be in standard CIDR format",
  "overlapping_cidr": "The range cannot overlap with existing duplicated ranges",
  "duplicated_cidr": "This subnet already exists in your monitored network",
  "required_cidr": "Please enter a CIDR address",
  "boundary_cidr": "The CIDR must be aligned with the network boundary. Ensure the host bits are set to zero",
  "empty_subnet": "Please enter a subnet mask",
  "invalid_subnet": "Please enter a valid subnet mask",
  "invalid_gateway": "Please enter a valid gateway",
  "gateway_not_in_subnet": "Gateway is not in the subnet you provided",
  "networks_intersection": "Queries and management networks intersect",
  "passwords_not_match": "Passwords do not match",
  "empty_current_password": "Please enter your current password",
  "empty_password": "Please enter a new password",
  "empty_retype_password": "Please retype your new password",
  "invalid_password": "Please enter a valid password",
  "duplicate_smtp_server": "SMTP server with this name already exists",
  "duplicate_syslog_server": "Syslog server with this name already exists",
  "duplicate_group_name": "Group name already exists",
  "empty_port": "Please enter a port",
  "invalid_port": "Please enter a valid port number",
  "invalid_device_url": "Please enter valid device URLs",
  "too_many_device_url": "Maximum 32 URLs are allowed",
  "duplicate_device_url": "Device URLs list contains duplicate addresses",
  "invalid_ssl": "Please enter a valid SSL host",
  "empty_hostname": "Please enter a hostname",
  "empty_url": "Please enter a URL",
  "invalid_hostname": "Please enter a valid hostname",
  "empty_client_id": "Please enter a client ID",
  "empty_client_secret": "Please enter API client secret",
  "empty_number_of_assets": "Please enter number of assets",
  "empty_asset_groups": "Please enter asset groups",
  "empty_start_ip": "Please enter start IP",
  "empty_end_ip": "Please enter end IP",
  "end_ip_greater_then_start": "End IP should be higher than start IP",
  "empty_multiple_ip": "Please enter at least one address",
  "invalid_multiple_ip": "IP list contains an invalid address",
  "invalid_number": "Value must be an integer no larger than {{ count }}",
  "duplicate_multiple_ip": "IP list contains duplicates",
  "download_failed": "Failed to download",
  "min_exclusion_conditions": "Select at least one condition to exclude by",
  "invalid_file_size": "PCAP file exceeds the maximum size of",
  "empty_type": "Please select a type",
  "empty_criticality": "Please select a criticality",
  "empty_segment": "Please select network segment",
  "empty_purdue_level": "Please select a Purdue level",
  "upload_invalid_type_format": "Not a valid database file",
  "require_domain": "Please enter a valid domain name",
  "require_base_dn": "Please enter a base DN",
  "admin_group_dn": "Please enter an admin group DN",
  "admin_user_group": "Please enter a read-only group DN",
  "invalid_range": "Enter a valid range",
  "invalid_regex_port": "Port can only contain numbers between 1 and 65535, or a range separated by hyphens",
  "invalid_single_port": "Port can only contain numbers between 1 and 65535",
  "existing_port": "Port already exists",
  "config_queries": "Could not fetch config",
  "grouped_queries": "Could not fetch run-now data",
  "key_generate_failure": "Failed to generate a key",
  "empty_expiration": "Please enter expiration period",
  "invalid_expiration": "Please enter a period between 1 and 365",
  "empty_description": "Please enter a description",
  "empty_backplane": "Please enter backplane name",
  "invalid_time_range": "End time should be later than start time",
  "empty_user_group": "Please select a User Group",
  "empty_idp_id": "Please enter IDP ID",
  "empty_idp_url": "Please enter IDP URL",
  "empty_ca": "Please enter certificate data",
  "empty_groups_attr": "Please enter groups attribute",
  "empty_username_attr": "Please enter username attribute",
  "empty_server": "Please enter server",
  "empty_community_strings": "Please enter community strings",
  "empty_auth_password": "Please enter an authentication password",
  "empty_private_password": "Please enter a private password",
  "policy_not_found": "Policy not found",
  "plugin_not_found": "Vulnerability not found",
  "active_query_not_found": "Active query not found",
  "group_not_found": "Group not found",
  "item_not_found": "Item not found",
  "download_execution_csv_failed": "Failed to download last run log",
  "empty_sensor_input": "At least one sensor must be selected",
  "empty_source_input": "At least one source must be selected",
  "empty_credentials": "Please select at least one credential",
  "empty_network_areas": "Please select at least one network area"
}
